import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "rahidev_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (url) => (url?.startsWith("/") ? `${BACKEND_URL}${url}` : url);

export async function uploadFile(path, file, extra = {}) {
  const form = new FormData();
  form.append("file", file);
  Object.entries(extra).forEach(([k, v]) => form.append(k, v));
  const { data } = await api.post(path, form, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}
